import { SET_PROFILE, SET_USER } from "../../constants";

const initialState = {
    user: null,
};

export const UserReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER:
            return {
                ...state,
                user: action.payload,
            };

        case SET_PROFILE:
            return {
                ...state,
                user: {
                    ...state.user,
                    user_settings: action.payload,
                },
            };

        default:
            return state;
    }
};